import { Controller } from 'stimulus';
import Animation from 'src/animation';

import sprite1 from 'images/animations/wide_loads/1.png';
import sprite2 from 'images/animations/wide_loads/2.png';
import sprite3 from 'images/animations/wide_loads/3.png';
import sprite4 from 'images/animations/wide_loads/4.png';
import sprite5 from 'images/animations/wide_loads/5.png';

export default class extends Controller {
  connect() {
    const ratio = 1.378;

    const options = {
      canvasWidth: this.element.offsetWidth,
      canvasHeight: this.element.offsetWidth / ratio,
      sources: this.sources,
      steps: this.steps,
      element: this.element
    };

    let rangeEl = this.element.querySelector('input')

    rangeEl.min = 0;
    rangeEl.max = 4;
    rangeEl.step = 1;
    rangeEl.value = 0;

    const animation = new Animation(options);

    let initialSprite = new Image();
    initialSprite.src = sprite1;
    initialSprite.onload = function() {
      animation.render(0)
    }
  }

  get sources() {
    return [
      sprite1,
      sprite2,
      sprite3,
      sprite4,
      sprite5
    ]
  }

  get steps() {
    return [
      'This is a legal load. Nothing is required.',
      'As the load exceeds the trailer width, state-issued permits,  safety flags and an “Oversize” banner will be required.',
      'As the width increases, flashing lights and/or one or more escort vehicles may be required.',
      'If the load width exceeds the normal lane width of the road, escort vehicles will be required and additional route reviews may be required.',
      'As you move into super load territory expect weeks, or even months, for permit approvals from each state along the route. Additionally, 3rd party reviews, police escorts, utility approval, and other safety check may be required.'
    ]
  }
}
